//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerBackTitleShare from '@/components/header/headerBackTitleShare'
// 猎聘分享
import { share4App } from '@/crowd_fund/active1017/share.js'
//swiper
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
export default{
    components: {
      headerBackTitleShare,
      swiper,
      swiperSlide
    },
    data(){
        return{
            shareInfo:{},     //app分享信息
            tabsArr:[
              { text:'关注热度',
                imgSrc:require('../../assets/images/active1017/icon_hot.png'),
                imgSrcing:require('../../assets/images/active1017/icon_hoting.png')
              },
              { text:'募捐额度',
                imgSrc:require('../../assets/images/active1017/icon_money.png'),
                imgSrcing:require('../../assets/images/active1017/icon_moneying.png')
              }
            ],
            tabsAct:0,
            tabNumberArr:[
                require('../../assets/images/active1017/no1.png'),
                require('../../assets/images/active1017/no2.png'),
                require('../../assets/images/active1017/no3.png'),
            ],
            actiPv:0, //活动关注度人次
            actiUv:0,  //爱心支持用户人次
            actiMoneySum:0,  //活动募集资金总额
            loveList:[],    //爱心动态
            projectsJK:[],  //健康扶贫
            titleImgJK:'',
            titleJK:'',
            titleJKID:'',
            projectsJY:[],  //教育扶贫
            titleImgJY:'',
            titleJY:'',
            titleJYID:'',
            projectSuc:[],  //达成目标
            projectCha:[],  //慈善榜单
            progressLen:0,
            isApp:false,
            // banner CMS swiper
            ActHeadImgArr:[],
            ActHeadOption:{
              pagination:{
                el:'.bannerPagi',
                clickable:true,
              },
              paginationClickable: true,
              autoplay: {
                delay: 1500, //3秒切换一次
                disableOnInteraction: false
              },
              loop: true,
              // observer: true,
              // coverflow: {
              //   rotate: 30,
              //   stretch: 10,
              //   depth: 60,
              //   modifier: 2,
              //   slideShadows : true
              // }
            }
        }
    },
    methods:{
        tabsChange(key){
            this.tabsAct = key;
            this.getChannelPro(key+1);
        },
        getTotalNum(){
            this.$https.get(this.BASE_URL+'cfs/zc/activity/activityTitleSum').then(res => {
                if(res.data.code=='CFSI0000'){
                    this.actiPv = res.data.data.actiPv;
                    this.actiUv = res.data.data.actiUv;
                    this.actiMoneySum = res.data.data.actiMoneySum;
                }
            }).catch(err =>{console.log(err)})
        },
        getLoveList(){
          this.$https.get(this.BASE_URL+'cfs/zc/activity/activityLoveTopFifty').then(res => {
            if(res.data.code=='CFSI0000'){
              this.loveList = res.data.data;

              let actDTop = document.getElementById('actDWrap')
              let index = 0;
              var Timer = null;
              clearInterval(Timer)
              Timer = setInterval(function () {
                let len = actDTop.getElementsByTagName('p').length;
                if(len<4){
                  clearInterval(Timer)
                }else{
                  if(index>(len-3) * 20){
                    index = 0
                  }
                  actDTop.style.top = (-1)*index+'px';
                  index++
                }
              },100)
            }
          }).catch(err =>{console.log(err)})
        },
        getProjects(type){
          this.$https.get(this.BASE_URL+'cfs/zc/activity/activityProjectType?projectType='+type).then(res => {
            if(res.data.code=='CFSI0000'){
                if(type == 1){
                  this.projectsJK = res.data.data;
                  this.titleImgJK = res.data.data[0].proAppImgPath;
                  this.titleJK = res.data.data[0].projectName;
                  this.titleJKID = res.data.data[0].projectId;
                  if(this.projectsJK.length > 1){
                    this.projectsJK = this.projectsJK.splice(1,this.projectsJK.length)
                  }
                }else if(type ==2){
                  this.projectsJY = res.data.data;
                  this.titleImgJY = res.data.data[0].proAppImgPath;
                  this.titleJY = res.data.data[0].projectName;
                  this.titleJYID = res.data.data[0].projectId;
                  if(this.projectsJY.length > 1){
                    this.projectsJY = this.projectsJY.splice(1,this.projectsJY.length)
                  }
                }
            }
          }).catch(err =>{console.log(err)})
        },
        getSuccessPro(){
          this.$https.get(this.BASE_URL+'cfs/zc/activity/activityProjectFull').then(res => {
            if(res.data.code=='CFSI0000'){
                if(res.data.data != null){
                  this.projectSuc = res.data.data;
                }
            }
          }).catch(err =>{console.log(err)})
        },
        getChannelPro(type){
          this.$https.get(this.BASE_URL+'cfs/zc/activity/activityChannel?reqType='+type).then(res => {
            if(res.data.code=='CFSI0000'){
              this.projectCha = res.data.data;
              if(type == 1){
                this.progressLen = res.data.data[0].channelLoveFocus;
              }else{
                this.progressLen = res.data.data[0].channelLoveMoney;
              }
            }
          }).catch(err =>{console.log(err)})
        },
        // isAuthorization() {
        //   window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.wechatAppid + "&redirect_uri=" + encodeURIComponent( this.appjump_url + "/pages/index/index.html#/active1017?isSingle=single")+"&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
        // },
        // wxchat () {
        //   let self = this;
        //   this.$jsonp(this.BASE_URL+'uts/invitationCode/wxAuthorization',{
        //     'code':this.getUrlParamURLysas("code")
        //   }).then( data => {

        //     if(data.status == 200) {
        //       self.zcuserid = data.result.userId;
        //       self.zctoken = data.result.logintoken;
        //       self.zcnickname = data.result.nickname
        //       localStorage.setItem('zcuserid',data.result.userId);
        //       localStorage.setItem('zcopenid',data.result.openid);
        //       localStorage.setItem('zcunionid',data.result.unionid);
        //       localStorage.setItem('zcnickname',data.result.nickname);
        //       localStorage.setItem('zcheadimgurl',data.result.headimgurl);
        //       localStorage.setItem('zctoken',self.zctoken);
        //     }
        //   })
        // },
        liepin_Share4App(){
          console.log('liepin_Share4App')
          let self = this;
          share4App({
              type: [17, 16],
              showshare: true, // 是否展示分享按钮
              mediaType: 0,//链接
              title: '中国社会帮扶网',
              shareTitle: '1017 一起“助扶”',
              shareUrl: window.location.href,
              desc: '“扶”星高照 助力脱贫攻坚',
              thumburl: self.appjump_url+'/pages/index/shareIcon/actShare.jpeg',
              imgUrl: self.appjump_url+'/pages/index/shareIcon/actShare.jpeg', 
          })
        },
        wechatshareneedkey  () {
          if (window.TencentNews && window.TencentNews.setShareArticleInfo) {
            // 腾讯app
            window.TencentNews.setShareArticleInfo('1017 一起“助扶”','','“扶”星高照 助力脱贫攻坚',window.location.href,this.appjump_url+'/pages/index/shareIcon/actShare.jpeg');
          // }else if(/sunland/i.test(navigator.userAgent) && window.JSBridge && window.JSBridge.doAction){
          //   // console.log('/sunland/i.test(navigator.userAgent)')
          //   // 尚德企业app
          //   // 显示隐藏App标题栏右上角的分享按钮
          //   window.JSBridge.doAction('showShareButton','{}','{}');
          //   // 设置分享内容
          //   let lineLink=window.location.href;//要分享页面的地址，即该页面地址
          //   this.shareInfo = {
          //     title : '1017 一起“助扶”',
          //     content: '“扶”星高照 助力脱贫攻坚',
          //     url : lineLink,
          //     imgUrl: this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
          //   };
          //   window.JSBridge.doAction('setShareContent', '{}', JSON.stringify(this.shareInfo));
          }else if (/ulxdapp/.test(navigator.userAgent.toLowerCase())) {
            console.log('邮乐小店————isYlxd：中国邮政APP')
            let lineLink=window.location.href;//要分享页面的地址，即该页面地址
            this.shareInfo = {
              title : '1017 一起“助扶”',
              desc: '“扶”星高照 助力脱贫攻坚',
              link : lineLink,
              // link : this.appjump_url+'/pages/index/index.html#/active1017?isShare=share',
              imgUrl: this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
            };
          }
          else if(this.isWeixinCient()){
            // let lineLink=window.location.href.split('#')[0];
            let lineLink=window.location.href;//要分享页面的地址，即该页面地址
            this.shareInfo = {
              title : '1017 一起“助扶”',
              desc: '“扶”星高照 助力脱贫攻坚',
              link : lineLink,
              // link : this.appjump_url+'/pages/index/index.html#/active1017?isShare=share',
              imgUrl: this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
            };
            // this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
            this.setWeixinConfig(this.shareInfo);
          }else{
            this.shareInfo = '{"picurl":"'+this.appjump_url+'/pages/index/shareIcon/actShare.jpeg","title":"1017 一起“助扶”","type":"'+2+'","projectId":"","text":"“扶”星高照 助力脱贫攻坚","url":"'+this.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode+'","ischange":'+'"2"'+'}'
            // this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
            // window.share.getShareDetailView(this.shareInfo);
          }
        },
        goDetail(acr001) {
          // 详情跳转
          if(this.isWeixinCient()) {
            // if(this.$route.query.isSingle == "single") {
              this.$router.push('/zcprojectDetail/'+acr001+'/'+localStorage.getItem("zcuserid")+'/'+encodeURIComponent(localStorage.getItem("zcnickname"))+'/'+localStorage.getItem("zctoken")+'?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
            // }else {
            //   this.$router.push('/zcprojectDetail/'+acr001+'/'+this.$route.params.userid+'/'+encodeURIComponent(this.$route.params.nickname)+'/'+this.$route.params.token+'?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
            // }
          }else {
            // if (this.isApp==true){
            if (this.isApp==true && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
              // app跳转
              if(this.$route.query.token){
                this.$router.push('/zcprojectDetail/'+acr001+'/'+this.$route.query.userId+'/'+encodeURIComponent(this.$route.query.Nickname)+'/'+this.$route.query.token+'?isShare=share&headImage='+this.$route.query.headImage+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
              }else{
                if(window.nativeApp){
                  var userInfoStr = window.nativeApp.getUserInfo();
                  // console.log('userInfoStr:::::::::'+userInfoStr)
                  if(userInfoStr=='(null)'||userInfoStr=='null'||userInfoStr=='undefined'||userInfoStr=='(undefined)'||userInfoStr==''||userInfoStr==null||userInfoStr==undefined){
                    this.$router.push('/zcprojectDetail/'+acr001+'/null/null/null?isShare=share&headImage=null'+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
                  }else{
                    var userInfo = JSON.parse(userInfoStr);
                    // console.log('userInfo::::::::'+userInfo.headpathString)
                    this.$router.push('/zcprojectDetail/'+acr001+'/'+userInfo.useridString+'/'+encodeURIComponent(userInfo.userNickString)+'/'+userInfo.accTokenString+'?isShare=share&headImage='+userInfo.headpathString+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
                  }
                }else{
                  this.$router.push('/zcprojectDetail/'+acr001+'/null/null/null?isShare=share&headImage=null'+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
                }
              }
            }else if (this.isApp==true && /(Android)/i.test(navigator.userAgent)){
              console.log('userInfoStr = window.nativeApp2.getUserInfo()')
              if(window.nativeApp2){
                var userInfoStr = window.nativeApp2.getUserInfo();
                console.log('userInfoStr:::::::::'+userInfoStr)
                if(userInfoStr=='(null)'||userInfoStr=='null'||userInfoStr=='undefined'||userInfoStr=='(undefined)'||userInfoStr==''||userInfoStr==null||userInfoStr==undefined){
                  this.$router.push('/zcprojectDetail/'+acr001+'/null/null/null?isShare=share&headImage=null'+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
                }else{
                  // console.log('userInfo = JSON.parse(userInfoStr)')
                  var userInfo = JSON.parse(userInfoStr);
                  console.log('userInfo::::::::'+userInfo.headPath)
                  this.$router.push('/zcprojectDetail/'+acr001+'/'+userInfo.userid+'/'+encodeURIComponent(userInfo.userNick)+'/'+userInfo.accToken+'?isShare=share&headImage='+userInfo.headPath+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
                }
              }else{
                this.$router.push('/zcprojectDetail/'+acr001+'/null/null/null?isShare=share&headImage=null'+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
              }
            }else{
              this.$router.push('/zcprojectDetail/'+acr001+'/null/null/null?isShare=share&headImage=null'+'&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode)
            }
          }
        },
        getUrlParamURLysas(name) {
          var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
          var r = window.location.search.substr(1).match(reg);
          if (r != null){
              return unescape(r[2]);
          }
          return "";
        },
        getBannerImgs(){
          let self = this;
          this.$jsonp(this.wechat_url+'/shfp/revision/zspt/columnget/getArticlePage',{
                'pageSize':10,'pageIndex':1,'pageId':this.cms_1017act
             }).then(res => {
            self.ActHeadImgArr=res.result.informationInfos;
            // self.ActHeadOption={
            //   pagination: '.bannerPagi',
            //   paginationClickable: true,
            //   // slidesPerView: 'auto',
            //   centeredSlides:true,
            //   loop:true,
            //   speed:600, 
            // }
            // console.log(res)
            // console.log(self.ActHeadImgArr)
          }).catch(err =>{console.log(err)})
        },
        BannerRouteTo(url){
          if(url&&url!='http://'&&url!='https://'){
            window.location.href = url;
          }
        }
    },
    mounted(){
        this.getBannerImgs()
        this.getTotalNum();
        this.getLoveList();
        this.getProjects(1);
        this.getProjects(2);
        this.getSuccessPro();
        this.getChannelPro(1);
        this.wechatshareneedkey();
    },
    created(){
      var ua = window.navigator.userAgent;
      console.log(ua);
      // 腾讯app
      var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);
      // 尚德app
      var isSunland = ua.match(/sunland/i);
      // 中国邮政app-邮乐购
      var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());
      // 猎聘
      var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
      var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
      var isLiePin = isLiePinAndroid || isLiePinIos;

      if(isTxNews&&isTxNews[1]){
          this.L('anlpbaFlag','2')
          let TXscripts = document.createElement('script');
          TXscripts.type = 'text/javascript';
          TXscripts.src = 'https://mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1';
          document.getElementsByTagName('head')[0].appendChild(TXscripts)
      }else if(isSunland&&isSunland[0]){
        console.log('尚德app')
        JSBridge.doAction('hideShareButton', JSON.stringify({}), JSON.stringify({}));
        this.isApp=true;
        this.L('anlpbaFlag','2')
      }else if (isYlxd) {
        this.isApp=true;
        this.L('anlpbaFlag','2')
        console.log('这是中国邮政app-邮乐购')
      }else if(isLiePin){
        this.L('anlpbaFlag','2')
        this.liepin_Share4App()
        console.log('猎聘app')
      }
      else if (this.isWeixinCient()) {
        if(this.getUrlParamURLysas("code") == null || this.getUrlParamURLysas("code") ==''){
          var ActChannel_strs = (this.$route.query.channelCode?('&channelCode='+this.$route.query.channelCode):'')+(this.$route.query.ActCode?('&ActCode='+this.$route.query.ActCode):'');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.wechatAppid + "&redirect_uri=" + encodeURIComponent( this.appjump_url + "/pages/index/#/active1017?isShare=share"+ActChannel_strs)+"&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
        }
      }else{
         this.isApp=true;
      }

      // isApp=1 显示app头部
      // this.isApp = this.$route.query.isApp
      // let u = navigator.userAgent
      // this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      // 判断是不是从链接进来的
      // if(this.isWeixinCient()) {
      //   if(this.$route.query.isSingle == "single") {
      //     // 从链接进去，需要页面授权
      //     if(this.getUrlParamURLysas("code") == null || this.getUrlParamURLysas("code") ==''){
      //       this.isAuthorization()
      //     }else {
      //       this.wxchat()
      //     }
      //   }
      // }
    }
}



// WEBPACK FOOTER //
// ./src/crowd_fund/active1017/active1017.vue